module.exports = __webpack_public_path__ + "static/media/p-logo-rakuten.7ca5ad6a.svg";